import {Requestor} from 'hegyd/core/resources/assets/js/utils/Requestor.js'

export default class CartLineQuantityUpdator extends HTMLInputElement {
    constructor() {
        super();

        this.productId = this.dataset.productId;
        this.returnTemplates = JSON.parse(this.dataset.returnTemplates ?? '[]');
        this.mainContainer = document.getElementById('main-container');
    }

    connectedCallback() {
        this.watch();
    }

    disconnectedCallback() {
        this.unwatch();
    }

    watch() {
        this.addEventListener('change', this.updateQuantity.bind(this));
    }

    unwatch() {
        this.removeEventListener('change', this.updateQuantity);
    }

    updateQuantity() {
        const quantity = parseInt(this.value);
        if ( ! quantity) {
            return;
        }

        const requestor = new Requestor();

        requestor.sendRequest( this.dataset.href, 'PUT', {
            'product_id': this.productId,
            'quantity': quantity,
            'return_templates': this.returnTemplates,
        }, (data) => {
            if (this.mainContainer) {
                this.mainContainer.updateCartViews( data );
            }
        });
    }
}
